angular.module( 'acme.view.application.importExport.list', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.importExport.list.controllers'
])

.config(function config( $stateProvider ) {
  var importExportList = {
    name: 'application.importExport.list',
    url: '/list',
    views: {
      "subview-main": {
        controller: 'ImportExportListController',
        controllerAs: '$ctrl',
        templateUrl: 'views/application/views/importExport/list/list.tpl.html'
      }
    },
    data: {
      pageTitle: 'Import / Export - Jobs',
      permissions: ['IMPEX_EXECUTE'],
      enablePreferences: true
    }
  };

  $stateProvider
    .state(importExportList);
});
